import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import MaterialSpinner from "../../../../ui/materialSpinner";
import {THUMBNAIL_SIZES} from "../../../../../misc/utils";
import {featureThumbnailUrl} from "../../../../../misc/helpers";
import {baseNewImagesPath} from "../../../../assets";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {LOOK_OVERLAYS} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";

const LookFeatureImage = (props) => {

  const {lookActiveFeature, intl, withoutGallery, featureIsLocked, setLookOverlayOpened} = props;
  const [isLoading, toggleLoader] = useState(true);
  const [galleryImages, setGalleryImages] = useState([]);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    let featureGalleryImages = (Array.isArray(lookActiveFeature.dbFeature.galleryImages)
      && lookActiveFeature.dbFeature.galleryImages.length) ? lookActiveFeature.dbFeature.galleryImages : [];
    setGalleryImages([{
      url: featureThumbnailUrl(lookActiveFeature) || `${baseNewImagesPath}images/image-not-found.png`,
      preview: featureThumbnailUrl(lookActiveFeature, THUMBNAIL_SIZES.medium)
    },  // main image thumbnail
      ...featureGalleryImages
    ]);
    setActiveImageIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature]);

  const arrowClick = (analyticsLabel, nextIndex) => {
    Analytics.sendClickEvent(analyticsLabel);
    if (featureIsLocked) {
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
      return false
    }
    if (nextIndex !== activeImageIndex) {
      toggleLoader(true);
      setActiveImageIndex(nextIndex)
    }
  }

  const backButtonClick = () => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureImageChangeLeft
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureImageChangeLeft;
    const nextIndex = galleryImages[activeImageIndex - 1] ? activeImageIndex - 1 : galleryImages.length - 1
    arrowClick(analyticsLabel, nextIndex)
  };

  const nextButtonClick = () => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureImageChangeRight
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureImageChangeRight;
    const nextIndex = galleryImages[activeImageIndex + 1] ? activeImageIndex + 1 : 0
    arrowClick(analyticsLabel, nextIndex)
  };
  //
  // const thumbnailClick = (index) => {
  //   props.toggleGalleryVisible(true);
  //   props.setGalleryActiveImageIndex(index);
  // };

  // console.log("galleryImages", galleryImages);
  const mainImageUrl = galleryImages[activeImageIndex];

  return (
    <div className={"lk-image"}>
      {withoutGallery ? null : (
        <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                    className="look-icon look-icon--small"
                    disabled={galleryImages.length <= 1}
                    onClick={backButtonClick}>
          <ChevronLeftIcon/>
        </IconButton>
      )}
      <div className="lk-image__main">
        {isLoading || !mainImageUrl ? <MaterialSpinner/> : null}
        <div className="lk-image__main-image-container">
          {mainImageUrl ? <img className={"lk-image__main-image" + (isLoading ? " lk-image__main-image--loading" : "")}
            // onClick={() => thumbnailClick(activeImageIndex)}
                               src={mainImageUrl.url} onLoad={() => toggleLoader(false)} alt=""/> : null}
        </div>
      </div>
      {withoutGallery ? null : (
        <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                    className="look-icon look-icon--small"
                    disabled={galleryImages.length <= 1}
                    onClick={nextButtonClick}>
          <ChevronRightIcon/>
        </IconButton>
      )}
    </div>
  )
};

LookFeatureImage.propTypes = {
  withoutGallery: PropTypes.bool,
  forFeature: PropTypes.shape(featureInterface),
  featureIsLocked: PropTypes.bool,
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature} = store.lookState;
  return {
    lookActiveFeature: ownProps.forFeature || lookActiveFeature,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureImage)
);
